import { showSuccessAlert } from "../../constants/alerts";
import { OffersActionTypes } from "./constants";

const INIT_STATE = {
  offers: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface OfferActionType {
  type:
    | OffersActionTypes.API_RESPONSE_SUCCESS
    | OffersActionTypes.API_RESPONSE_ERROR
    | OffersActionTypes.GET_OFFERS
    | OffersActionTypes.ADD_OFFERS
    | OffersActionTypes.DELETE_OFFERS
    | OffersActionTypes.UPDATE_OFFERS
    | OffersActionTypes.CLEAR_ERROR;

  payload: {
    actionType?: string;
    data?: any | {};
    error?: string;
    message?: string;
  };
}

const Offers = (state: any = INIT_STATE, action: OfferActionType): any => {
  switch (action.type) {
    case OffersActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case OffersActionTypes.GET_OFFERS: {
          return {
            ...state,
            offers: action.payload.data,
            loading: false,
            initialLoading: false,
            error: null,
          };
        }

        case OffersActionTypes.ADD_OFFERS: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }

        case OffersActionTypes.UPDATE_OFFERS: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }

        case OffersActionTypes.DELETE_OFFERS: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }

        default:
          return { ...state };
      }

    case OffersActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case OffersActionTypes.GET_OFFERS: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case OffersActionTypes.ADD_OFFERS: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case OffersActionTypes.UPDATE_OFFERS: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case OffersActionTypes.DELETE_OFFERS: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }

        default:
          return { ...state };
      }

    case OffersActionTypes.GET_OFFERS:
      return { ...state, loading: true, initialLoading: true };
    case OffersActionTypes.ADD_OFFERS:
      return { ...state, loading: true };
    case OffersActionTypes.UPDATE_OFFERS:
      return { ...state, loading: true };
    case OffersActionTypes.DELETE_OFFERS:
      return { ...state, loading: true };

    case OffersActionTypes.CLEAR_ERROR:
      return { ...state, error: null };

    default:
      return { ...state };
  }
};

export default Offers;
